import React from 'react';
import classnames from 'classnames';
import propTypes from 'prop-types';
import pick from 'lodash/pick';
import { Nav, NavLink, TabContent, TabPane } from 'reactstrap';

import { noop } from 'lib/noop';

import PlacementOnlyTab from './PlacementOnlyTab';
import WebReadyTab from './WebReadyTab';
import styles from './ControlArea.css';
import { AMP_FILTER_OPTIONS, AMP_TABS } from '../const';

// order of keys determines nav tab order
const TAB_MAP = {
  [AMP_TABS.WEB_READY]: {
    Component: WebReadyTab,
    propsToPick: [
      'changeFilter',
      'clearQueryData',
      'filter',
      'queryByAssetId',
      'queryByWorkfrontId'
    ]
  },
  [AMP_TABS.PLACEMENT_ONLY]: {
    Component: PlacementOnlyTab,
    propsToPick: ['onAsset']
  }
};

/**
 * control area for amp modal
 * @param {object} props - component props
 * @returns {React.Component} ControlArea
 */
const ControlArea = props => {
  const { activeTab, changeActiveTab, 'data-test-id': testId } = props;
  return (
    <div className={styles.controlArea}>
      <Nav className={styles.nav}>
        {Object.keys(TAB_MAP).map(key => {
          const tabClasses = classnames([
            styles.navTab,
            key === activeTab && styles.navTabActive
          ]);
          const tabTestId = [testId, key].join('-');
          return (
            <NavLink
              key={key}
              className={tabClasses}
              onClick={changeActiveTab}
              tag="div"
              data-test-id={tabTestId}
            >
              {key}
            </NavLink>
          );
        })}
      </Nav>
      <TabContent activeTab={activeTab}>
        {Object.entries(TAB_MAP).map(([key, { Component, propsToPick }]) => (
          <TabPane key={key} tabId={key}>
            <Component {...pick(props, propsToPick)} />
          </TabPane>
        ))}
      </TabContent>
    </div>
  );
};

// NOTE: eslint/react cannot detect these props bc of lodash pick - do not remove!
// changeFilter,
// clearQueryData,
// filter,
// onAsset,
// queryByAssetId,
// queryByWorkfrontId
ControlArea.propTypes = {
  activeTab: propTypes.string,
  changeActiveTab: propTypes.func,
  changeFilter: propTypes.func,
  clearQueryData: propTypes.func,
  'data-test-id': propTypes.string,
  filter: propTypes.string,
  onAsset: propTypes.func,
  queryByAssetId: propTypes.func,
  queryByWorkfrontId: propTypes.func
};
ControlArea.defaultProps = {
  activeTab: AMP_TABS.WEB_READY,
  changeActiveTab: noop,
  changeFilter: noop,
  clearQueryData: noop,
  'data-test-id': 'amp-modal-tab',
  filter: AMP_FILTER_OPTIONS[0],
  onAsset: noop,
  queryByAssetId: noop,
  queryByWorkfrontId: noop
};

export default ControlArea;
